import moment from "moment-timezone";

export const momentJapan = (datetime?: string) =>
  moment(datetime).tz("Asia/Tokyo");
